import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { NgbModalRef, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { MarineApiService } from 'src/app/core/services/api/marine-api.service';
import { cities } from '../../models/cities';
import { countries } from '../../models/countries';
import { Charter } from '../../models/data/charter';

@Component({
  selector: 'app-charter-create-edit',
  templateUrl: './charter-create-edit.component.html',
  styleUrls: ['./charter-create-edit.component.scss']
})
export class CharterCreateEditComponent implements OnInit {
  public charter: Charter;
  public cities = cities;
  public countries = countries;

  @ViewChild('charterModal') charterModal;
  @Output() submit: EventEmitter<Charter> = new EventEmitter<Charter>();
  @Output() closeModal: EventEmitter<any> = new EventEmitter<any>();

  modalRef: NgbModalRef;

  constructor(
    private modalService: NgbModal,
    private api: MarineApiService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService) { }

  ngOnInit(): void {
  }

  // handle the popup
  open(charter: Charter) {
    this.charter = Object.assign(new Charter(), charter);
    this.modalRef = this.modalService.open(this.charterModal, {
      backdrop: 'static',
      keyboard: false,
      size: 'lg',
      centered: true
    });
  }

  close() {
    this.closeModal.emit();
    this.modalRef.close();
  }

  onSubmit() {
    if (this.charter.id) {
      this.spinner.show();
      this.api.updateCharter(this.charter).subscribe(
        c => {
          this.spinner.hide();
          this.submit.emit(c);
          this.closeModal.emit();
        }
      )
    } else {
      this.spinner.show();
      this.api.createCharter(this.charter).subscribe(
        c => {
          this.spinner.hide();
          this.submit.emit(c);
          this.closeModal.emit();
        }
      )
    }
  }


}

